module.exports = __webpack_public_path__ + "fonts/yubico_38x38.8306b1b970d5827880bf608262395984.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/yubico_38x38.png
// module id = 809
// module chunks = 9